export default __webpack_public_path__ + "static/media/Blog6.285ba681.png";